import { createDynamicThunk } from ".";

/**
 * LIST Users
 */
export const fetchUsersThunk = createDynamicThunk({
  typePrefix: "users/fetchUsersThunk",
  useHandleSearch: true,
});

/**
 * ADD / EDIT User
 */
export const submitUserThunk = createDynamicThunk({
  typePrefix: "users/submitUserThunk",
  endpoint: "/users",
  method: "POST",
});

/**
 * Fetch Supervisors
 */
export const fetchSupervisorAsDropdownThunk = createDynamicThunk({
  typePrefix: "fetchSupervisorAsDropdownThunk",
  endpoint: "/fetchWithoutPagination",
  method: "POST",
});

/**
 * Fetch Roles
 */
export const fetchRoleAsDropdownThunk = createDynamicThunk({
  typePrefix: "fetchRoleAsDropdownThunk",
  endpoint: "/roles/fetchWithoutPagination",
  method: "GET",
});

/**
 * Fetch Clients
 */
export const fetchClientAsDopdownThunk = createDynamicThunk({
  typePrefix: "fetchClientAsDopdownThunk",
  endpoint: "/fetchWithoutPagination",
  method: "POST",
});

export const updateRoleThunk = createDynamicThunk({
  typePrefix: "updateRoleThunk",
  endpoint: "/updateRole",
  method: "POST",
});